$max-badge-width: 171px;

:host {
  display: flex;
  background-color: $color-base-brand-yellow;
  justify-content: center;
  border-radius:$size-radius-xs;
  width: $max-badge-width;
  padding: 0 $size-space-sm;
}

smart-text {
  b {
    font-weight: 900;
    font-family: $font-family-primary;
    font-size: $size-typography-subtitle-1;
    line-height: $size-line-height-subtitle-1;
  }
}
